// features/conductTest/conductTestSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { updateCurrentTestBasicDetails } from '../features/trainerAsync';

const initialState = {
  id: null,
  testRegisterLink: "",
  currentTestDetails: {
    isRegistrationavailable: false,
    testbegins: false,
    testconducted: false,
    isResultgenerated: false,
  },
  registeredCandidates: [],
  questionsOfTest: [],
}; 

const conductTestSlice = createSlice({
  name: 'conductTest',
  initialState,
  reducers: {
    setConductTestId(state, action) {
      state.id = action.payload;
    },
    setTestRegisterLink(state, action) {
      state.testRegisterLink = action.payload;
    },
    changeIsRegistrationAvailable(state, action) {
      state.currentTestDetails.isRegistrationavailable = action.payload;
    },
    changeBeginTestStatus(state, action) {
      state.currentTestDetails = action.payload;
    },
    changeCandidatesOfTest(state, action) {
      state.registeredCandidates = action.payload;
    },
    changeQuestionsOfTest(state, action) {
      state.questionsOfTest = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateCurrentTestBasicDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCurrentTestBasicDetails.fulfilled, (state, action) => {
        //console.log("CurrentDetail",action.payload); 
        state.loading = false;
        state.currentTestDetails.isRegistrationavailable = action.payload.isRegistrationavailable;
        state.currentTestDetails.isResultgenerated= action.payload.isResultgenerated;
        state.currentTestDetails.testbegins=action.payload.testbegins;
        state.currentTestDetails.testconducted=action.payload.testconducted;
      })
      .addCase(updateCurrentTestBasicDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setConductTestId,
  setTestRegisterLink,
  changeIsRegistrationAvailable,
  changeBeginTestStatus,
  changeCandidatesOfTest,
  changeQuestionsOfTest,
} = conductTestSlice.actions;

export default conductTestSlice.reducer;
